import styles from "./index.module.css";

/**
 * A flexible arrow pointing right from the name bubble to the IBO's data.
 */
export default function EndArrow() {
  return (
    <div className={styles.container}>
      <div className={styles.line}></div>
      <div>
        <div className={styles.lineEnd}></div>
        <div className={styles.arrowHead}></div>
      </div>
    </div>
  );
}
